import { render } from "./SignInBibo.vue?vue&type=template&id=4df6223c"
import script from "./SignInBibo.vue?vue&type=script&lang=ts"
export * from "./SignInBibo.vue?vue&type=script&lang=ts"
script.render = render

export default script